import { MDBInput } from "mdb-react-ui-kit";
import { ASParamEditorProps } from "../ASParamEditor";

export interface ASStringParamProps extends ASParamEditorProps<string> {
    password?: boolean;
}

export const ASStringParam = (props: ASStringParamProps) => {

    return (
        <span style={{width: 200}}>
            <MDBInput
                type="text"
                value={props.currentValue ?? ""}
                disabled={props.disabled}
                maxLength={props.password ? 4 : undefined}
                onChange={ev => props.onCurrentValueChange(props.password ? passwordTransform(ev.currentTarget.value) : ev.currentTarget.value)}
            />
        </span>
        
    )
}

const passwordTransform = (val: string) => val.replace(/[^0-9]/g, '').slice(0,4);